import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import spqr2 from "../../../components/tables/pers-vnw-2";
import spqr3 from "../../../components/tables/pers-vnw-3";
import spqr4 from "../../../components/tables/pers-vnw-4";
import spqr40 from "../../../components/tables/pers-vnw-40";

const data = [
  {
    les: "2",
    table: spqr2
  },
  {
    les: "3",
    table: spqr3
  },
  {
    les: "4",
    table: spqr4
  },
  {
    les: "40",
    table: spqr40
  }
];

export default () => (
  <TableSelector
    defaultChapter="40"
    data={data}
    title="Persoonlijk voornaamwoord"
  />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/persoonlijk-voornaamwoord.js